import { useEffect, useState, useRef } from 'react'
import { backendAccessGet, backendAccessPost } from '../../../Utils/Authentication'

import Table from 'react-bootstrap/Table'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Form from 'react-bootstrap/Form'

export function ErrorDiv( props )
{
    const error = props.error 

    if( error )
    {
        return (
            <div style={{ border:"1px solid #C70015", 
                          borderRadius:'5px', padding:'5px'}}>
                { props.children }
            </div>

        )
    }

    return (
        <div style={{ border:"1px solid #FFFFFF", 
                      borderRadius:'5px', padding:'5px'}}>
            { props.children }
        </div>

    )
}

export function AddPositionModal( props )
{
    const showModal = props.showModal 
    const setShowModal = props.setShowModal 
    
    const departments = props.departments

    const addPosition = props.addPosition

    const [ name, setName ] = useState("")
    const [ capacity, setCapacity ] = useState("")
    const posDeps = useRef({})

    const [ nameError, setNameError ] = useState(false)
    const [ capError, setCapError ] = useState(false)
    const [ depError, setDepError ] = useState(false)

    useEffect( () => {
        if( showModal )
        {
            setName("")
            setCapacity("")
            posDeps.current = {}
            setNameError(false)
            setCapError(false)
            setDepError(false)
        }
    }, [ showModal] )

    const add = () => {
        setNameError(false)
        setCapError(false)
        setDepError(false)

        let has_error = false
        if( name == "" )
        {
            setNameError(true)
            has_error = true 
        }

        if( capacity == "" )
        {
            setCapError(true)
            has_error = true 
        }

        let capInt = parseInt(capacity);
        if( isNaN(capInt) )
        {
            setCapError(true)
            has_error = true;
        }

        var uids = []
        for (const [key, value] of Object.entries(posDeps.current))
        {
            if( value )
            {
                uids.push( key )
            }
        }

        if( uids.length == 0 )
        {
            setDepError(true)
            has_error = true
        }

        if( has_error )
        {
            return
        }

        addPosition(name, capacity, uids)
    }

    const handleChange = ( uid, checked ) => {
        if( checked )
        {
            posDeps.current[ uid ] = true
        }
        else
        {
            posDeps.current[ uid ] = false
        }
    }

    const isChecked = ( uid ) => {
        if( posDeps.current[uid] )
        {
            return true 
        }
        else 
        {
            return false
        }
    }

    return (
        <Modal show={showModal} onHide={ e => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Add Position</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding:'10px'}}>
                <div>
                    <b>Position Name</b>
                </div>
                <div style={{ marginBottom:'10px' }}>
                    <Form.Control value={name} onChange={e => setName(e.target.value)} isInvalid={nameError} />
                </div>
                <div>
                    <b>Position Capacity</b>
                </div>
                <div style={{ marginBottom:'10px' }}>
                    <Form.Control value={capacity} 
                                  onChange={e => setCapacity(e.target.value)} 
                                  isInvalid={capError} />
                </div>
                <div>
                    <b>Departments</b> 
                </div>
                <ErrorDiv error={depError}>
                    { departments.map( (d,idx) =>
                        <Form.Check type="checkbox" label={d.name} 
                                    onChange={ e => handleChange(d.uid, e.target.checked) }
                        />
                    )}
                </ErrorDiv>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={e => setShowModal(false)}>
                    Close
                </Button>
                <Button variant="primary" onClick={add}>
                    Add
                </Button>

            </Modal.Footer>

        </Modal>
    )
}

export function EditPositionModal( props )
{
    const position = props.position

    const showModal = props.showModal 
    const setShowModal = props.setShowModal 
    
    const updatePosition = props.updatePosition

    const [ capacity, setCapacity ] = useState("")
    const [ capError, setCapError ] = useState(false)

    useEffect( () => {
        if( showModal )
        {
            setCapacity(position.capacity)
            setCapError(false)
        }
    }, [ showModal] )

    const update = () => {
        setCapError(false)

        let has_error = false

        if( capacity == "" )
        {
            setCapError(true)
            has_error = true 
        }

        let capInt = parseInt(capacity);
        if( isNaN(capInt) )
        {
            setCapError(true)
            has_error = true;
        }

        if( has_error )
        {
            return
        }

        updatePosition(position.uid, capacity, setShowModal)
    }

    return (
        <Modal show={showModal} onHide={ e => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Position</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding:'10px'}}>
                <div>
                    <b>Position Capacity</b>
                </div>
                <div style={{ marginBottom:'10px' }}>
                    <Form.Control value={capacity} 
                                  onChange={e => setCapacity(e.target.value)} 
                                  isInvalid={capError} />
                </div> 
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={e => setShowModal(false)}>
                    Close
                </Button>
                <Button variant="primary" onClick={update}>
                    Update
                </Button>

            </Modal.Footer>

        </Modal>
    )
}

export function PositionRow( props )
{
    const index = props.index 
    const position = props.position

    const departments = props.departments

    const remove = props.remove
    const update = props.update

    const [ showEditModal, setShowEditModal ] = useState(false)

    const convertDepartments = ( dep_uids ) => {
        var deps = {}
        
        for( var idx in departments )
        {
            var d = departments[idx]
            deps[d.uid] = d.name
        }

        var out = []

        dep_uids = JSON.parse(dep_uids)
        for( var idx in dep_uids )
        {
            out.push( deps[ dep_uids[idx]] )
        }

        return JSON.stringify(out)
    } 

    return (
        <>
            <tr>
                <td> {index + 1} </td>
                <td> {position.name} </td>
                <td> {position.uid} </td>
                <td> {position.capacity} ({position.required})</td>
                <td> { convertDepartments(position.deps) } </td>
                <td> 
                    <ButtonGroup size="sm">
                        <Button variant="outline-secondary" onClick={e => setShowEditModal(true)}>Edit</Button>
                        <Button variant="outline-danger" onClick={e => remove(position.uid)}>Remove</Button>
                    </ButtonGroup>
                </td>
            </tr>
            <EditPositionModal position={position}
                               showModal={showEditModal}
                               setShowModal={setShowEditModal}
                               updatePosition={update}
            />

        </>
    )
}

export default function PositionBuilder( props )
{
    const activeKey = props.activeKey 

    const [ positions, setPositions ] = useState([])
    const [ departments, setDepartments ] = useState([])
    const [ showAddModal, setShowAddModal ] = useState(false)

    useEffect( () => {
        if( activeKey != "positions" )
        {
            return
        }

        backendAccessGet('/api/planner/rotations/positions/fetch/').then( res => {
            if('error_message' in res)
            {
                alert( res['error_message'] )
                return
            }

            console.log(res)

            setPositions( res.positions )
            setDepartments( res.departments )
        }) 

    }, [activeKey])

    const addPosition = ( name, capacity, uids ) => {
        var data = {}
        data['name'] = name
        data['capacity'] = parseInt(capacity)
        data['dep_uids'] = uids

        backendAccessPost('/api/planner/rotations/positions/add/', data ).then( res => {
            if('error_message' in res)
            {
                alert( res['error_message'] )
                return
            }
            setPositions( res['positions'] )
            setShowAddModal(false)
        }) 
    }

    const removePosition = ( uid ) => {
        var check = window.confirm("Delete position?")

        if( !check )
        {
            return;
        }

        let data = {}
        data['uid'] = uid

        backendAccessPost('/api/planner/rotations/positions/remove/', data ).then( res => {
            if('error_message' in res)
            {
                alert( res['error_message'] )
                return
            }
            setPositions( res['positions'] )
            //setShowAddModal(false)
        })
    }

    const updatePosition = ( uid, capacity, setShowModal ) => {
        let data = {}
        data['uid'] = uid 
        data['capacity'] = capacity
        
        backendAccessPost('/api/planner/rotations/positions/update/', data ).then( res => {
            if('error_message' in res)
            {
                alert( res['error_message'] )
                return
            }
            setPositions( res['positions'] )
            setShowModal(false)
        })
    }

    return (
        <>
            <div className="d-flex justify-content-center align-items-center" 
                 style={{ width:'100%', height:'100px'}}>
                <ButtonGroup size="sm">
                    <Button variant="secondary" 
                            onClick={ e => setShowAddModal(true)}   
                    >
                        Add Position
                    </Button>
                </ButtonGroup>
            </div>
            <div style={{ width:'100%' }}>
                <Table striped hover>
                    <thead>
                        <tr>
                            <th style={{ width: "20px"}}>#</th>
                            <th style={{ width: "80px"}}>Name</th>
                            <th style={{ width: "80px"}}>UID</th>
                            <th style={{ width: "40px"}}>Capacity</th>
                            <th style={{ width: "40px"}}>Departments</th>
                            <th style={{ width: "40px"}}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {positions.map( (p,idx) =>
                        <PositionRow position={p} 
                                     index={idx}
                                     departments={departments}
                                     remove={removePosition}
                                     update={updatePosition}
                        />
                        )}
                    </tbody>
                </Table>
            </div>
            <AddPositionModal showModal={showAddModal}
                              setShowModal={setShowAddModal}
                              departments={departments}
                              addPosition={addPosition}
            />


        </>
    )
}


